<script>
import { app } from '@/main'

import { AdPriceContactClicked, LogMiddlePageContactClicked } from '@/events'

import { getParent } from '@/functions'

export default {
  template: '<template></template>',
  components: {},
  props: {},
  data() {
    return {
      contactButtons: [],
    }
  },
  methods: {
    openContact() {
      app.mitt.emit('click-on-company-contact')
    },
  },
  created() {
    const owner = this
    const buttons = document.querySelectorAll('.js-contact-email-open')
    buttons.forEach(button => {
      owner.contactButtons.push(button)
      button.addEventListener('click', event => {
        owner.openContact()

        const parentAdPrice = getParent(event.target, 'ad-price')
        const parentMiddlePage = getParent(
          event.target,
          'ad__contact-container'
        )

        if (parentAdPrice !== null) {
          AdPriceContactClicked()
        }
        if (parentMiddlePage !== null) {
          LogMiddlePageContactClicked()
        }
      })
    })
    let evDataElement = document.getElementById('ev-data-widget-id')
    window.addEventListener('evdata.nodata', function () {
      evDataElement.style.display = 'none'
    })
  },
  beforeUnmount() {
    const owner = this
    this.contactButtons.forEach(button => {
      button.removeEventListener('click', () => {
        owner.openContact()
      })
    })
    this.contactButtons = []
  },
}
</script>
